module.exports = __webpack_public_path__ + "static/media/warning-colour.4bb3173c.svg";